import {
  AfterViewInit,
  Component,
  computed,
  DestroyRef,
  effect,
  ElementRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { HamburgerStateService } from "../hamburger-state.service";
import { ViewportRuler } from "@angular/cdk/scrolling";
import { auditTime, filter } from "rxjs/operators";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { asyncScheduler } from "rxjs";
import { NavigationStart, Router } from "@angular/router";

@Component({
  selector: "app-header-body-footer-adder",
  templateUrl: "./header-body-footer-adder.component.html",
  styleUrls: ["./header-body-footer-adder.component.scss"],
  standalone: false
})
export class HeaderBodyFooterAdderComponent implements AfterViewInit {
  @ViewChild("headerElement", { static: true, read: ElementRef })
  headerElement!: ElementRef;

  isUserLoggedIn = computed(() => this.hamburgerService.isUserLoggedIn() );
  constructor(
    private hamburgerService: HamburgerStateService,
    private viewContainerRef: ViewContainerRef,
    private viewportRuler: ViewportRuler,
    private destroyRef: DestroyRef,
    private router:Router
  ) {
    effect(() => {
      this.hamburgerMenuButtonListener();
    });
  }

  ngAfterViewInit() {
    //calculating Header Height on Viewport Resize
    this.viewportRuler
      .change(200)
      .pipe(takeUntilDestroyed(this.destroyRef), auditTime(200))
      .subscribe(() => {
        this.calculateHeaderHeight();
        const screenWidth = this.viewportRuler.getViewportSize().width;
      if (screenWidth > 992 && this.hamburgerService.isHamburger()) {
        this.hamburgerService.closeHamburgerMenu();
      }
      });
      //Calculating Header Height on Navigation Start
      this.router.events.pipe(
        takeUntilDestroyed(this.destroyRef),
        filter(event => event instanceof NavigationStart)
      ).subscribe(() => {
        this.calculateHeaderHeight();
      });
      this.calculateHeaderHeight();
  }
 
  calculateHeaderHeight() {
    asyncScheduler.schedule(() => {
      const el = this.headerElement.nativeElement as HTMLElement;
      const accurateHeight = getMaxVisualHeight(el)-1;
      this.hamburgerService.setHeaderHeight(accurateHeight);
    });
  }

  hamburgerMenuButtonListener() {
    const open = this.hamburgerService.isHamburger();
    if (open) {
      this.hamburgerService.openHamburgerMenu(this.viewContainerRef);
    } else {
      this.hamburgerService.closeHamburgerMenu();
    }
  }
}

function getMaxVisualHeight(el: HTMLElement): number {
  const firstVisibleChild = Array.from(el.querySelectorAll("*")).find(child => {
    const rect = (child as HTMLElement).getBoundingClientRect();
    return rect.height > 0;
  });

  if (firstVisibleChild) {
    const rect = (firstVisibleChild as HTMLElement).getBoundingClientRect();
    return rect.height;
  }

  return 0;
}

